import { WEB_SITE } from 'config/Config';
import { DrmEntityBackend, LinkEntityType } from 'v2/models';

export const entities: Record<string, DrmEntityBackend> = {
  'data-provider-details': DrmEntityBackend.DATA_VENDOR,
  'contact-details': DrmEntityBackend.CONTACT,
  'data-set-details': DrmEntityBackend.DATASET,
};

const isValidDomain = (parsedUrl: URL, referenceParsedUrl: URL) => {
  return (
    parsedUrl.protocol !== referenceParsedUrl.protocol ||
    parsedUrl.hostname !== referenceParsedUrl.hostname ||
    parsedUrl.port !== referenceParsedUrl.port
  );
};

const isDRMEntityPath = (
  entity: string,
  id: number,
  detail: string,
  entities: Record<string, DrmEntityBackend>
) => {
  return (
    !entity ||
    !Object.keys(entities).includes(entity) ||
    !Number.isFinite(id) ||
    detail !== 'detail'
  );
};

export const validateLink = (
  link: string
): [boolean, LinkEntityType | undefined] => {
  let parsedUrl;
  let referenceParsedUrl;

  try {
    parsedUrl = new URL(link);
    referenceParsedUrl = new URL(WEB_SITE || '');
  } catch (error) {
    return [false, undefined];
  }

  if (isValidDomain(parsedUrl, referenceParsedUrl)) {
    return [false, undefined];
  }

  const pathParts = parsedUrl.pathname.split('/');

  if (pathParts.length !== 4) {
    return [false, undefined];
  }

  const entity = pathParts[1];
  const id = parseInt(pathParts[2]);
  const detail = pathParts[3];

  if (isDRMEntityPath(entity, id, detail, entities)) {
    return [false, undefined];
  }

  return [
    true,
    {
      entity: entities[entity],
      id,
    },
  ];
};
